import { faqs } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于黑料视频网站使用的一些常见疑问解答</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-3 md:space-y-4">
          {faqs.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 cursor-pointer overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 text-sm md:text-base font-semibold text-foreground-800 hover:text-primary-500 transition-colors list-none">
                <span>{item.q}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 group-open:rotate-45 transition-transform duration-300 flex-shrink-0 ml-2">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}